import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputTextSF from '../../../widgets/form/InputTextSF'
import InputReadOnlyUI from '../../../widgets/form/InputReadOnlyUI'

const UserCreateModalUI = ({context, successMsg, errorList, setErrorList,
    // modes
    submitted, createMode,
    // event handlers
    onSubmit, onCancelClick,
    //
    firstName, onFirstNameChange, firstNameError, setFirstNameError,
    lastName, onLastNameChange, lastNameError, setLastNameError,
    email, onEmailChange, emailError, setEmailError,
  }) =>
  <ModalFormUI
    context={context}
    titleLabel='Add admin'
    buttonLabel='Add'
    cancelLabel='Cancel'
    isOpen={createMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >
    <InputTextSF type='text'  name='firstName' label='First name'
      required={true} maxLength={100} autoFocus={true}
      value={firstName} onChange={onFirstNameChange}
      error={firstNameError} setError={setFirstNameError}
    />
    <InputTextSF type='text'  name='lastName' label='Last name'
      required={true} maxLength={100}
      value={lastName} onChange={onLastNameChange}
      error={lastNameError} setError={setLastNameError}
    />
    <InputTextSF type='text'  name='email' label='Email'
      maxLength={40}
      value={email} onChange={onEmailChange}
      error={emailError} setError={setEmailError}
    />
  </ModalFormUI>

export default UserCreateModalUI
